import { Component, ViewChild, ElementRef, OnInit, TemplateRef } from "@angular/core";

import { AssessmentService } from "../../shared/components/assessments/services/assessment.service";
import { GuideService } from "../guide/services/guide.service";

import { IAssessment } from "../../shared/components/assessments/models/assessment";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { IGuide } from "../guide/models/guide";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  templateUrl: "./steps.component.html",
  providers: [GuideService],
  styles: [`a.btn-primary { color: white; }`]
})

export class StepsComponent {

  @ViewChild("iframe", { static: false }) iframe: ElementRef;

  fullScreen: boolean = false;
  isPreAssessmentCompleted: boolean = false;
  isPostAssessmentCompleted: boolean = false;
  preAssessmentScore: number;
  postAssessmentScore: number;
  preAssessmentId: number = 0;
  preAssessments: Array<IAssessment> = [];
  postAssessments: Array<IAssessment> = [];

  selectPlan: string = '';

  steps: Array<boolean> = [false, false, false, false];
  assessmentViewDetailsModalRef: BsModalRef;
  guide: IGuide;


  constructor(private assessmentService: AssessmentService,
    private guideService: GuideService, private modalService: BsModalService,
    private route: ActivatedRoute,
    private router: Router) {
    this.loadGuide();
    this.getOnlyAssessment();    

    this.route
      .queryParams
      .subscribe(params => {        
        this.selectPlan = params['selectPlan'] || '';
      });
  }

  toggleStep(val: number) {
    this.steps[val] = !this.steps[val];
  }

  openModal(template: TemplateRef<any>) {
    const initialState = {
      mode: "add",
    };

    this.assessmentViewDetailsModalRef = this.modalService.show(template, { class: "modal-xl", ignoreBackdropClick: true, initialState });
  }

  cancel() {
    this.assessmentViewDetailsModalRef.hide();
  }

  loadGuide() {

    this.guideService.get().subscribe(res => {

      this.guide = res;
    });

  }

  downloadCertification() {
    this.assessmentService.downloadCertification();
  }

  getOnlyAssessment() {
    this.assessmentService.getOnlyAssessment().subscribe(result => {
      if (result != null) {
        this.preAssessments = result.filter(item => item.type === 0);
        this.postAssessments = result.filter(item => item.type === 1);
        if (this.preAssessments != null && this.preAssessments.length > 0) {
          this.preAssessmentScore = this.preAssessments[0].score;
          this.steps[0] = true;
          this.isPreAssessmentCompleted = true;
          this.preAssessmentId = this.preAssessments[0].id;          
        } else {
          this.steps[0] = false;
          this.steps[2] = false;
        }

        if (this.postAssessments != null && this.postAssessments.length > 0) {
          var i;
          var currentPostAssessmentScore = [];
          for (i = 0; i < this.postAssessments.length; i++) {
            currentPostAssessmentScore.push(this.postAssessments[i].score);                       
          }
          this.postAssessmentScore = Math.max(...currentPostAssessmentScore);
          this.steps[2] = true;
          this.isPostAssessmentCompleted = true;
        } else {
          this.steps[2] = false;
        }
      } else {
        this.steps[0] = false;
        this.steps[2] = false;
      }
    });
  }
}
